import { useEffect } from 'react';
import { Button } from '@quicktools/shared-components';
import MobileSliderModal from '@quicktools/shared-components/components/core/MobileSliderModal/MobileSliderModal';

import analytics from '../../services/analytics';
import CategoryFilter from '../CategoryFilter';

import useStyles from './styles';

interface IFilterModal {
  changeCategory: (category: string, text: string, selected: string) => void;
  closeModal: () => void;
  selectedCategory: string;
}

export default function FilterModal({
  changeCategory,
  closeModal,
  selectedCategory,
}: IFilterModal) {
  const styles = useStyles();

  useEffect(() => {
    analytics.filterOpen();
  }, []);

  return (
    <MobileSliderModal onClose={closeModal}>
      <CategoryFilter
        heading="Select Category"
        onSelectItem={changeCategory}
        selectedCategory={selectedCategory}
      />
      <Button className={styles.button} type="button" variant="primary" onClick={closeModal}>
        Apply
      </Button>
    </MobileSliderModal>
  );
}
